var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0697 7.99967C11.1326 6.93678 12.8675 6.93678 13.9304 7.99967L20.4504 14.5197C20.7433 14.8126 20.7433 15.2874 20.4504 15.5803C20.1575 15.8732 19.6826 15.8732 19.3897 15.5803L12.8697 9.06033C12.3926 8.58322 11.6075 8.58322 11.1304 9.06033L4.61041 15.5803C4.31751 15.8732 3.84264 15.8732 3.54975 15.5803C3.25685 15.2874 3.25685 14.8126 3.54975 14.5197L10.0697 7.99967Z",
    fill: "#03182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleArrow);
export default __webpack_public_path__ + "static/media/simple-arrow.59f6e2adb9051473b10a92ce953e3eda.svg";
export { ForwardRef as ReactComponent };